import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { LumenDiagnosticService } from '@app/features/lumen-diagnostics/lumen-diagnostics.service';
import { environment } from '@env/environment';

@Component({
    selector: 'app-lumen-diagnostics',
    templateUrl: './lumen-diagnostics.component.html',
    styleUrls: ['./lumen-diagnostics.component.scss'],
    standalone: false
})
export class LumenDiagnosticsComponent implements OnInit {
  @ViewChild('diagnosticsTable') diagnosticsTable: MatTable<any>;
  isLoading: boolean = false;
  storeNumber: string = '';
  netboxLink: string = null;
  diagnostics = [];
  diagnosticsDisplayColumns = ["type", "status", "message"];
  diagnosticsDataSource = new MatTableDataSource<any>(this.diagnostics);
  circuitNotFound: boolean = false;

  constructor(private lumenDiagnosticsService: LumenDiagnosticService) { }

  ngOnInit() {
  }

  getDiagnostics() {
    this.isLoading = true;
    this.circuitNotFound = false;
    return this.lumenDiagnosticsService.getDiagnosticsDetail(this.storeNumber).then((observable) => {
      observable.toPromise().then((response) => {
        let data = response["message"];
        if (data != "Circuit not found") {
          this.diagnosticsDataSource.data = response["message"];
          this.diagnosticsTable.renderRows();
          this.netboxLink = `${environment.netboxUrl}/dcim/sites/?slug=` + this.storeNumber;
          this.isLoading = false;
        } else {
          this.circuitNotFound = true;
          this.isLoading = false;
        }
      });
    });
  }

}
